module.exports = __webpack_public_path__ + "static/media/advantages-left.7cbac3aa.png";